module.exports = __webpack_public_path__ + "posture/static/img/face.dd616e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/face.png
// module id = GkfD
// module chunks = 1